import Image from "./Image";
import moment from "moment";

export const statusColor = (status) => {
  if (status) {
    return "active-btn";
  } else {
    return "inactive-btn";
  }
};

export const changeDateFormat = (date) => moment(date).format("DD-MM-YYYY");

export const changeMonthFormat = (date) => moment(date).format("MM");
export const changeYearFormat = (date) => moment(date).format("YYYY");


export const singaporeTime = (val, format = 'DD-MM-YYYY HH:mm:ss') => {
  if (val) {
    const utcTime = moment.utc(val, format);
    const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = singaporeTime.format('DD-MM-YYYY HH:mm:ss');
    return formattedTime;
  }
}

export const singaporeTimeOnly = (val) => {
  if (val) {
    const utcTime = moment.utc(val, 'DD-MM-YYYY HH:mm:ss');
    const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = singaporeTime.format('HH:mm:ss');
    return formattedTime;
  }
}

export const timeFormatOnly = (val) => {
  if (val) {
    const utcTime = moment.utc(val, ['DD-MM-YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']);
    // const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = utcTime.format('HH:mm:ss');
    return formattedTime;
  }
}

export const singaporeTimeWithoutSeconds = (val, format = 'DD-MM-YYYY HH:mm:ss') => {
  if (val) {
    const utcTime = moment.utc(val, format);
    const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = singaporeTime.format('DD-MM-YYYY HH:mm');
    return formattedTime;
  }
}

export const isSameDate = (startDate, endDate) => {
  return moment(startDate, 'DD-MM-YYYY HH:mm:ss').isSame(moment(endDate, 'DD-MM-YYYY HH:mm:ss'), 'day');
}

export const getDateOnly = (date) => {
  return moment(date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY");
}

export const removeSecondsFromColonSeperatedString = (value) => {
  let splitString = value.split(":");
  splitString.pop();

  let resultString = splitString.join(":");
  return resultString;
}

export const eventColor = (event) => {
  if (event) {
    return "event-start";
  } else {
    return "event-stop";
  }
};

export const iconColor = (event) => {
  if (event === Number(0)) {
    return <Image name="gray.gif" />;
  } if (event <= Number(3)) {
    return <Image name="yellow.gif" />;
  } else if (event <= Number(5)) {
    return <Image name="green.gif" />;
  } else if (event <= Number(7)) {
    return <Image name="red.gif" />
  } else if (event > Number(7)) {
    return <Image name="blue.gif" />;
  }
};


export const iconCount = (event) => {

  if (event === Number(0)) {
    return "count-gray";
  } else if (event <= Number(3)) {
    return "count-yellow";
  } else if (event <= Number(5)) {
    return "count-green";
  } else if (event <= Number(7)) {
    return "count-red";
  } else if (event > Number(7)) {
    return "count-blue";
  }
};

export const exportToJson = (dataCsv, fileName) => {
  downloadFile({
    data: dataCsv,
    fileName: fileName,
    fileType: 'text/csv',
  })
}

export const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType })
  const a = document.createElement('a')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

//image type for aws service
export const profile_image_type = 1;
export const floor_image_type = 2;
export const admin_image_type = 3;

//report types for employee
export const attendance_type = 1;
export const absentee_type = 2;

//reason types for unauthorised employee
export const all_reason = 0;
export const unauthorised_entry = 1;
export const not_in_zone_at_working_hours = 2;
export const working_beyond_work_permit_hours = 3;

export const calculateEightHoursAgo = (givenTime) => {
  if (givenTime) {
    const dateParts = givenTime.split(/[- :]/);
    const givenDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], dateParts[3], dateParts[4], dateParts[5]);
    const currentDate = new Date();
    const differenceInSeconds = Math.floor((currentDate - givenDate) / 1000);
    if (differenceInSeconds < 28800) { // 8 hours = 28800 seconds
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const formatLastDetected = (givenTime) => {
  if (!givenTime) return null;
  const given = moment.utc(givenTime).utcOffset('+08:00');
  if (!given.isValid()) return null;
  const formatted = given.format('DD-MM-YYYY HH:mm');
  const now = moment();
  let diff = Math.max(0, now.diff(given, 'seconds'));
  const days = Math.floor(diff / 86400); diff -= days * 86400;
  const hours = Math.floor(diff / 3600); diff -= hours * 3600;
  const minutes = Math.floor(diff / 60);
  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  parts.push(`${minutes}m`);
  return `${formatted} (${parts.join(' ')} ago)`;
};

export const calculateTimeAgo = (givenTime) => {
  if (givenTime) {
    // const givenTime = "19-02-2024 09:14:07";
    const dateParts = givenTime.split(/[- :]/);
    const givenDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], dateParts[3], dateParts[4], dateParts[5]);

    // const givenDate = new Date(givenTime);
    const currentDate = new Date();
    const differenceInSeconds = Math.floor((currentDate - givenDate) / 1000);

    let interval = Math.floor(differenceInSeconds / 31536000);
    if (interval >= 1) {
      return `${interval} year${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 2592000);
    if (interval >= 1) {
      return `${interval} month${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 86400);
    if (interval >= 1) {
      return `${interval} day${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 3600);
    if (interval >= 1) {
      return `${interval} hour${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 60);
    if (interval >= 1) {
      return `${interval} minute${interval === 1 ? '' : 's'} ago`;
    }
    return `${differenceInSeconds} second${differenceInSeconds === 1 ? '' : 's'} ago`;
  }
};